export default __webpack_public_path__ + "static/media/close_grey.7ffb1967.svg";